export default __webpack_public_path__ + "static/og-image-cd84d3bb976bf727da2a6a399c7e5e88.png";